export { usarPermissionamento } from "./usarPermissionamento"
